import moment from 'moment';

const isDateValid = date => !!date && moment(date).isValid();

export default isDateValid;
